/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';

import './index.scss';

const ImageButton = ({ description, image, value, handleClickEvent }) => {
  const hasValue = value !== null && value !== undefined && value.length > 0;
  const classNames = hasValue ? 'image-button has-value' : 'image-button';
  const valueComponent = hasValue ? <div className="image-button__value">{value}</div> : null;

  return (
    <div className="image-button-wrapper">
      <button type="button" onClick={handleClickEvent} className={classNames}>
        <div className="image-button__image">{image}</div>
        {description}
      </button>

      {valueComponent}
    </div>
  );
};

ImageButton.propTypes = {
  image: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  handleClickEvent: PropTypes.func.isRequired,
  value: PropTypes.string,
};

ImageButton.defaultProps = {
  value: null,
};

export default ImageButton;
